/* eslint-disable import/prefer-default-export */
import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

export type ButtonSize = "sm" | "md";

type IButtonProps = {
  primary?: boolean;
  secondary?: boolean;
  tertiary?: boolean;
  centered?: boolean;
  type: string;
  icon?: boolean;
  size: ButtonSize;
  btnPrimaryBgColor?: string;
  btnPrimaryTextColor?: string;
  btnPrimaryBorderColor?: string;
  btnPrimaryBgColorHover?: string;
  btnPrimaryTextColorHover?: string;
  btnPrimaryBorderColorHover?: string;
  btnSecondaryBgColor?: string;
  btnSecondaryTextColor?: string;
  btnSecondaryBorderColor?: string;
  btnSecondaryBgColorHover?: string;
  btnSecondaryTextColorHover?: string;
  btnSecondaryBorderColorHover?: string;
};

export const StyledButton = styled.button<IButtonProps>`
  font-family: ${({ theme }) => theme.fontFamily};

  background-color: ${({ primary, theme }) =>
    primary && theme.colors.btnPrimaryBgColor};
  background-color: ${({ secondary, theme }) =>
    secondary && theme.colors.btnSecondaryBgColor};
  background-color: ${({ tertiary, theme }) => tertiary && theme.colors.btnSecondaryBgColor};
  background-color: ${({ disabled, theme }) => disabled && theme.colors.btnDisabledBgColor};
  background-color: ${({ icon }) => icon && "unset"};

  color: ${({ theme }) => theme.colors.white};
  color: ${({ theme, tertiary }) => tertiary && theme.colors.btnSecondaryTextColor};
  color: ${({ icon, theme }) => icon && theme.colors.btnPrimaryTextColor};
  color: ${({ disabled, theme }) => disabled && theme.colors.btnDisabledTextColor};

  font-weight: bold;

  border: ${({ theme }) => `1px solid ${theme.colors.btnPrimaryBorderColor}`};
  border: ${({ theme, secondary }) =>
    secondary && `1px solid ${theme.colors.btnSecondaryBorderColor}`};
  border: ${({ theme, disabled }) =>
    disabled && `1px solid ${theme.colors.btnDisabledBorderColor}`};
  border: ${({ icon }) => icon && "none"};

  border-radius: ${({ theme }) => theme.borderRadiusSmall};
  min-width: ${({ size }) => size !== "sm" && "100px"};
  min-width: ${({ icon }) => icon && "unset"};
  margin: ${({ centered }) => centered && "0 auto"};
  display: ${({ centered }) => centered && "flex"};
  font-size: ${({ theme, size }) => {
    if (size === "sm") {
      return "14px";
    }

    return theme.fontSize.normal.desktop;
  }};
  cursor: pointer;

  padding: ${({ icon, size, theme }) => {
    // TODO: Deprecate "Icon Button"
    // This button already has too much responsibly, styling for a totally
    // different type of button (only an icon) does not belong here.
    if (icon) {
      return theme.spacing.s;
    }

    if (size === "sm") {
      return "6px 10px";
    }

    if (size === "md") {
      return "10px 15px";
    }
  }};

  &:hover {
    background-color: ${({ theme }) => theme.colors.btnPrimaryBgColorHover};
    background-color: ${({ tertiary, theme,  }) => tertiary && theme.colors.btnSecondaryBgColorHover};
    background-color: ${({ disabled, theme }) =>
      disabled && theme.colors.btnDisabledBgColorHover};
    background-color: ${({ icon }) => icon && "unset"};

    cursor: ${({ disabled }) => disabled && "not-allowed"};

    color: ${({ theme }) => theme.colors.btnPrimaryTextColorHover};
    color: ${({ icon, theme }) => icon && theme.colors.btnPrimaryTextColorHover};
    color: ${({ theme, tertiary }) => tertiary && theme.colors.btnSecondaryTextColorHover};
    color: ${({ theme, disabled }) => disabled && theme.colors.btnDisabledTextColorHover};
    
    border: ${({ theme, disabled }) =>
      `1px solid ${disabled ? theme.colors.muted : theme.colors.btnDisabledBorderColorHover}`};
    border: ${({ theme, tertiary }) =>
      tertiary && `1px solid ${theme.colors.btnSecondaryBorderColorHover}`};
    border: ${({ icon }) => icon && "none"};
  }

  ${mediaMaxWidth.tablet} {
    font-size: ${({ theme }) => theme.fontSize.normal.mobile};
  }
`;

StyledButton.displayName = "StyledButton";
